import React,{useState,useEffect} from 'react'
import {URL} from '../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { invokeTrainers } from '../ServiceCalls/ApiCalls';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './AddTrainer.css'

function AddTrainersComponent() {

  const navigate = useNavigate()
  const[inputField,setInputField] = useState({
        trainer_name:'',
        designation:'',
        profile_pic:''
  })
  const[trainerName,setTrainerName] = useState('')
  const[designation,setDesignation] = useState('')
  const[profilePic,setProfilePic] = useState('')
  const[trainerid,setTrainerId] = useState('')
  const[rowid,setRowId]= useState('')
  const[status,setStatus]=useState(false)
  const[trainers,setTrainers] = useState([])
  const[isLoading,setIsLoading] = useState(true)
  const[isRefreshing,setIsRefreshing] = useState(false)

  useEffect(() =>{
    if(!localStorage.getItem('user')){
        navigate('/')
    }
    async function GetData(){
        setIsLoading(true);
        try {
            const trainersList = await invokeTrainers()
            console.log(trainersList)
            setTrainers(trainersList)
        } catch (error) {
            console.error('Error fetching trainers:', error);
            toast.error('Failed to load trainers', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } finally {
            setIsLoading(false);
        }
    }

    GetData()
  },[])

  const refreshTrainers = async () => {
    setIsRefreshing(true);
    try {
      const trainersList = await invokeTrainers()
      setTrainers(trainersList)
      
      toast.success('Trainers refreshed successfully!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error('Error refreshing trainers:', error);
      toast.error('Failed to refresh trainers', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsRefreshing(false);
    }
  };

  const options = (method = "GET",body) =>{
    return {
        method,
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(body)
    }
  }
  const handleAddTrainers = (e) => {
    const{name,value} = e.target;
    setInputField({...inputField,[name]:value})
  }
  const handleEditTrainers = (e) =>{
    const{name,value} = e.target;

    if(name === 'trainer_name')
        setTrainerName(value)
    if(name === 'designation')
        setDesignation(value)
  }
  const handleSubmitTrainers = async(e) =>{

    e.preventDefault()

    const{trainer_name,designation,profile_pic} = inputField;
    
    const formData = new FormData()
    
    formData.append('trainer_name',trainer_name)
    formData.append('designation',designation)
    formData.append('profile_pic',profile_pic)

        try {
            const add_trainers_response = await fetch(`${URL}` + '/trainers/create',{
                method: "POST",
                body: formData
            });
            const add_trainers_data = await add_trainers_response.json();

            if(add_trainers_response.ok){
                console.log('Data',add_trainers_data)
                //alert('Trainer Added !!')
                setTrainers(prev => [...prev,add_trainers_data])
                toast.success('🦄 Wow Trainer Added!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                reset()
            }
            else{
               // alert('Trainer Add Failed...')
               toast.error('🦄 OOps Add Trainer Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
    
        } catch (error) {
            console.log(error)
        }
    
  }
  const handleUpdateTrainers = async(e) => {

    e.preventDefault()

    const formData = new FormData()
    
    if(trainerName)
        formData.append('trainer_name',trainerName)
    if(designation)
        formData.append('designation',designation)
    if(profilePic)
        formData.append('profile_pic',profilePic)

        try {
            const update_trainers_response = await fetch(`${URL}` + '/trainers/'+`${trainerid}`,{
                method: "PATCH",
                body: formData
            });
            if(update_trainers_response.ok){
                const update_trainers_status = await update_trainers_response.json();
                const dataUpdate = [...trainers]
                dataUpdate[rowid] = update_trainers_status;
                setTrainers([...dataUpdate])
                setStatus(true)
            }
            else{
               // alert('Trainer Add Failed...')
               toast.error('🦄 OOps Edit Trainer Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
    
        } catch (error) {
            console.log(error)
        }
  } 

  const deleteTrainers = async(tr_id,rowid) => {
    window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rowid+1}`)
    try{
        const delete_trainers_response = await fetch(`${URL}` + '/trainers/'+`${tr_id}`, options("DELETE"));
        if(delete_trainers_response.ok){
           // alert(`Trainer at ${rowid+1}  is Deleted !!`)
            const dataDelete = [...trainers];
            dataDelete.splice(rowid,1)
            setTrainers([...dataDelete])
            toast.success('🦄 Wow Trainer Deleted!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else{
            toast.error('🦄 OOps Del Trainer Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }catch(err){
        console.log(err)
    }
  }
  const editTrainer = (t,rid) => {
    setTrainerName(t.trainer_name)
    setDesignation(t.designation)
    setProfilePic(t.profile_pic)
    setTrainerId(t._id)
    setRowId(rid)
    setStatus(false)
  }
  const reset = (e) =>{
    e.preventDefault();
    setInputField({ trainer_name: '', designation: '',profile_pic:'' });
  }

  return (
    <div className="admin-panel">
        <div className='container admin-container'>
            <div className="row mt-5">
              <div className="col-md-12 col-sm-12">
                <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h3 className="mb-1">
                      <i className="fa fa-users text-warning me-2"></i>
                      Manage Trainers ({trainers.length})
                    </h3>
                    <p className="text-muted">Add new trainers and manage existing trainer records</p>
                  </div>
                  <div className="failed-bookings-actions">
                    <button 
                      className="btn btn-outline-secondary me-2"
                      onClick={refreshTrainers}
                      disabled={isRefreshing}
                    >
                      {isRefreshing ? (
                        <>
                          <i className="fa fa-spinner fa-spin me-1"></i>
                          Refreshing...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-refresh me-1"></i>
                          Refresh
                        </>
                      )}
                    </button>
                    <button 
                      className="btn btn-primary"
                      onClick={() => navigate('/user')}
                    >
                      <i className="fa fa-arrow-left me-1"></i>
                      Back to Dashboard
                    </button>
                  </div>
                </div>
              </div>
            </div>
            


            {/* Add Trainer Section */}
            <div className="row mb-5">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">
                    <i className="fa fa-plus-circle text-primary me-2"></i>
                    Add New Trainer
                  </h4>
                </div>
                <div className="row">
                  <div className="col-md-8 col-lg-6">
                    <form onSubmit={handleSubmitTrainers} encType="multipart/form-data">
                      <div className="mb-3">
                          <label htmlFor="name" className="form-label">Trainer Name</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            id="name" 
                            name="trainer_name"
                            value={inputField.trainer_name}
                            onChange={e => handleAddTrainers(e)} 
                            required
                            placeholder="Enter name" autoComplete='off'/>
                      </div>
                      <div className="mb-3">
                          <label htmlFor="designation" className="form-label">Designation</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            id="designation" 
                            name="designation"
                            value={inputField.designation} 
                            onChange={e => handleAddTrainers(e)} 
                            required
                            placeholder="Enter Designation" autoComplete='off'/>
                      </div>
                      <div className="mb-3">
                          <label htmlFor="image" className="form-label">Upload Image</label>
                          <input 
                            type="file" 
                            className="form-control" 
                            id="image"
                            name="profile_pic"
                            required
                            onChange={e => setInputField({...inputField,profile_pic:e.target.files[0]})} 
                            placeholder="Upload Image"/>
                      </div>
                      <div className="d-flex gap-2">
                        <button 
                          type="submit" 
                          className="btn btn-primary">
                          <i className="fa fa-plus me-1"></i>
                          Add Trainer
                        </button>
                        <button 
                          onClick={e => reset(e)}
                          className="btn btn-outline-secondary">
                          <i className="fa fa-refresh me-1"></i>
                          Reset
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* Existing Trainers Section */}
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">
                    <i className="fa fa-list text-warning me-2"></i>
                    Existing Trainers
                  </h4>
                </div>
                
                {isLoading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="text-center">
                      <div className="spinner-border text-warning" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3 text-muted">Loading trainers...</p>
                    </div>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className='table table-bordered table-hover'>
                        <thead className="table-warning text-center">
                            <tr>
                                <th className='text-center'>S.No</th>
                                <th className='text-center'>Trainer Name</th>
                                <th className='text-center'>Designation</th>
                                <th className='text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                trainers.length > 0 ?
                                trainers.map((t,idx) =><tr key={idx}>
                                    <td className="text-center">{idx+1}</td>
                                    <td>{t.trainer_name}</td>
                                    <td>{t.designation}</td>
                                    <td className="text-center">
                                        <div className="btn-group" role="group">
                                          <button 
                                            className="btn btn-outline-primary btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#editModalPop"
                                            onClick={() =>editTrainer(t,idx)}
                                            title="Edit Trainer"
                                          >
                                            <i className="fa fa-pencil"></i>
                                          </button>
                                          <button 
                                            onClick={() =>deleteTrainers(t._id,idx)}
                                            className="btn btn-outline-danger btn-sm"
                                            title="Delete Trainer"
                                          >
                                            <i className="fa fa-trash"></i>
                                          </button>
                                        </div>
                                    </td>
                                </tr>)
                                :
                                <tr>
                                    <td colSpan={4} className="text-center text-muted py-4">
                                      <i className="fa fa-users fa-2x mb-2 d-block text-muted"></i>
                                      No trainers found
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
        </div>
        
        <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="editModalPop">
              <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                      <div className="modal-header">
                          <h5 className="modal-title" id="staticBackdropLabel">Edit Trainer</h5>
                          <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              //onClick={() => handleReset()} 
                              aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                          {
                              status ?
                                  <div className="container">
                                      <div className="row my-3">
                                          <div className="col-md-12 col-sm-12 d-flex flex-column justify-content-center border-1">
                                              <div className="success-img"></div>
                                              <h4 className="text-success text-center m-3">Row Updated Successfully !!!</h4>
                                          </div>
                                      </div>
                                  </div>
                                  :
                                  <div className="container">
                                      <div className="row">
                                      <div className="col-md-6 col-md-12">
                                              <form onSubmit={handleUpdateTrainers} enctype="multipart/form-data">
                                                  <div class="container">
                                                      <div class="mb-3">
                                                          <label for="name" class="form-label">Trainer Name</label>
                                                          <input
                                                              type="text"
                                                              class="form-control"
                                                              id="name"
                                                              name="trainer_name"
                                                              value={trainerName}
                                                              onChange={e => handleEditTrainers(e)}
                                                              placeholder="Enter name" autoComplete='off' />
                                                      </div>
                                                      <div class="mb-3">
                                                          <label for="designation" class="form-label">Designation</label>
                                                          <input
                                                              type="text"
                                                              class="form-control"
                                                              id="designation"
                                                              name="designation"
                                                              value={designation}
                                                              onChange={e => handleEditTrainers(e)}
                                                              placeholder="Enter Designation" autoComplete='off' />
                                                      </div>
                                                      <div class="mb-3">
                                                          <label for="image" class="form-label">Upload Image</label>
                                                          <input
                                                              type="file"
                                                              class="form-control"
                                                              id="image"
                                                              name="profile_pic"
                                                              onChange={e => setProfilePic(e.target.files[0])}
                                                              placeholder="Upload Image" />
                                                      </div>
                                                      <button
                                                          type="submit"
                                                          class="btn btn-primary">Submit</button>

                                                  </div>
                                              </form>

                                          </div>
                                      </div>
                                  </div>
                          }

                      </div>
                      <div className="modal-footer">
                          {
                              status ?
                                  <button
                                      type="button"
                                      className="btn btn-secondary"
                                      //onClick={() => handleReset()} 
                                      data-bs-dismiss="modal">Close</button>
                                  :
                                  null
                          }

                      </div>
                  </div>
              </div>
          </div>
        <ToastContainer/>
    </div>
  )
}

export default AddTrainersComponent